import { BoxProps, Flex, Text, Textarea } from '@modusign/design-system';
import { ChangeEvent, FocusEventHandler } from 'react';
import { Brand } from 'utility-types';

type StringShorterThanMaxLength = Brand<string, 'StringShorterThanMaxLength'>;

interface LimitedTextareaProps extends Omit<BoxProps<'textarea'>, 'onChange'> {
  autoFocus?: boolean;
  maxLength?: number;
  placeholder?: string;
  value: string;
  onChange: (value: StringShorterThanMaxLength) => void;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
}

function LimitedTextarea({
  autoFocus = false,
  maxLength = 1000,
  placeholder = '',
  value,
  onChange,
  onBlur,
  ...props
}: LimitedTextareaProps) {
  function handleValueChange(e: ChangeEvent<HTMLTextAreaElement>) {
    const { value } = e.target;
    /**
     * maxLength 속성으로 글자수 제한을 했지만 한글의 경우
     * 추가로 입력할 수 있는 버그가 있어서 maxLength 개수 이후 글자는 삭제합니다.
     * 컴포넌트 props maxLength까지만 상위로 전달하게 수정합니다.
     */
    onChange(
      (value.length > maxLength ? value.slice(0, maxLength) : value) as StringShorterThanMaxLength
    );
  }

  return (
    <Flex flexDirection="column" position="relative" width="100%" zIndex={0}>
      <Textarea
        autoFocus={autoFocus}
        data-testid="limited-text"
        height="50px"
        maxLength={maxLength}
        p={3}
        placeholder={placeholder}
        position="relative"
        sx={{
          border: '1px solid #e1e1e1',
          '&:focus ~ .LimitedTextarea__character-count': {
            mt: '3px',
            opacity: 1,
            transition: '0.3s',
          },
          ...props.sx,
        }}
        value={value}
        width="100%"
        zIndex={1}
        {...props}
        onBlur={onBlur}
        onChange={handleValueChange}
      />
      <Text
        className="LimitedTextarea__character-count"
        color="textNeutralVeryLight"
        fontSize="xs"
        mb={4}
        mr="5px"
        opacity={0}
        sx={{
          overflow: 'hidden',
          width: '100%',
          zIndex: 0,
        }}
        textAlign="right"
      >
        {value.length} / {maxLength}
      </Text>
    </Flex>
  );
}

export default LimitedTextarea;
